import { createAction } from 'redux-actions'

export const setVideoMuted = createAction('SET_VIDEO_MUTED')
export const setAudioMuted = createAction('SET_AUDIO_MUTED')
export const addTrackToRoom = createAction('ADD_TRACK_TO_ROOM')
export const detachTrack = createAction('DETACH_TRACK')
export const stopTrack = createAction('STOP_TRACK')
export const attachAudio = createAction('ATTACH_AUDIO')
export const attachVideo = createAction('ATTACH_VIDEO')
